import { render, staticRenderFns } from "./StepSix.vue?vue&type=template&id=2fdf3e81&scoped=true&"
import script from "./StepSix.vue?vue&type=script&lang=js&"
export * from "./StepSix.vue?vue&type=script&lang=js&"
import style0 from "./StepSix.vue?vue&type=style&index=0&id=2fdf3e81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf3e81",
  null
  
)

export default component.exports